package br.com.vvrefeicoes.portal.domain.model

enum class SocialConnectionType(
    val label: String,
) {
    BAILEYS("WhatsApp Baileys"),
    WHATSAPP_OFFICIAL("WhatsApp Oficial"),
    INSTAGRAM("Instagram"),
    FACEBOOK("Facebook"),
}

data class SocialConnection(
    val id: String,
    val name: String,
    val type: SocialConnectionType,
    val status: String,
    val qrCode: String?,
    val phoneNumber: String?,
    val credentialsConfigured: Boolean,
    val lastConnectedAt: String?,
)
